// extracted by mini-css-extract-plugin
module.exports = {"Auth":"Auth-Auth-1-gtTi","AuthPropositionList":"Auth-AuthPropositionList-214gVn","Button":"Auth-Button-g8T652","FourThreeProposition":"Auth-FourThreeProposition-3RUiKD"};